var React = require('react');

function Bulb (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M19.45 4.46L18.04 3.05L16.25 4.85L17.66 6.26L19.45 4.46ZM12 0.55L10 0.55L10 3.5L12 3.5L12 0.55ZM19 12.5L22 12.5L22 10.5L19 10.5L19 12.5ZM8 16.69L8 21.5L14 21.5L14 16.69C15.79 15.65 17 13.72 17 11.5C17 8.19 14.31 5.5 11 5.5C7.69 5.5 5 8.19 5 11.5C5 13.72 6.21 15.65 8 16.69ZM3 12.5L3 10.5L9.61651e-07 10.5L7.86805e-07 12.5L3 12.5ZM5.76 4.84L3.97 3.04L2.56 4.45L4.36 6.24L5.76 4.84Z","fill":"#F6A400"}));
}

Bulb.defaultProps = {"width":"22","height":"22","viewBox":"0 0 22 22","fill":"none"};

module.exports = Bulb;

Bulb.default = Bulb;
